<template>
  <v-container fluid class="pa-8">
    <v-row>
      <v-col cols="12">
        <home-current-page></home-current-page>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="12" md="6" lg="6">
        <h2 class="title-page">Mananciais</h2>
        <h4 class="mt-2 subtitle-page">
          Use o campo de busca para selecionar uma bacia e visualizar dados
          hidrológicos e meteorológicos.
        </h4>
      </v-col>
      <v-col cols="12" sm="12" md="6" lg="6">
        <map-search-form
          class="elevation-0"
          @result="searchResult = $event"
          @resultLocation="resultLocation($event)"
          :idClick="idClick"
          from="monitoring"
          category="Manancial"
        >
        </map-search-form>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <monitoring-map
          :searchResult="searchResult"
          :location="location"
          @idClick="idClick = $event"
        >
        </monitoring-map>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <monitoring-daily-forecast
          v-if="location"
          :location="location"
        ></monitoring-daily-forecast>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card color="primary darken-1">
          <div v-if="showAnimation" style="height: 300px">
            <loading-animation
              @loopComplete="loadAnimationComplete"
            ></loading-animation>
          </div>
        </v-card>
        <weekly-forecast
          v-show="!showAnimation && location"
          ref="monitoringWeeklyForecast"
          :location="location"
          :forecasts="forecasts"
          :flowForecasts="flowForecasts"
          :siprecDailyEstimated="siprecDailyEstimated"
          :prevHidroDaily="prevHidroDaily"
          :waterAvailability="waterAvailability"
          :qoper = "qoper"
          :q95="q95"
          :q95_50="q95_50"
          from="monitoring"
        ></weekly-forecast>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card color="primary darken-1">
          <div v-if="showAnimation" style="height: 300px">
            <loading-animation
              @loopComplete="loadAnimationComplete"
            ></loading-animation>
          </div>
        </v-card>
        <rain-estimation
          v-show="!showAnimation && location"
          ref="monitoringRainEstimation"
          :location="location"
          :forecasts="forecasts"
          :siprecDailyEstimated="siprecDailyEstimated"
          from="monitoring"
        >
        </rain-estimation>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import moment from 'moment';
import HomeCurrentPage from '../../components/common/HomeCurrentPage.vue';
import MapSearchForm from '../../components/common/MapSearchForm.vue';
import MonitoringMap from '../../components/monitoring/MonitoringMap';
import WeeklyForecast from '../../components/common/WeeklyForecast/WeeklyForecast.vue';
import MonitoringDailyForecast from '../../components/monitoring/MonitoringDailyForecast';
import RainEstimation from '../../components/common/RainEstimation/RainEstimation.vue';
import LoadingAnimation from '../../components/common/LoadingAnimation.vue';
import axios from 'axios';
export default {
  name: 'Monitoring',
  components: {
    MonitoringDailyForecast,
    WeeklyForecast,
    MonitoringMap,
    MapSearchForm,
    HomeCurrentPage,
    RainEstimation,
    LoadingAnimation,
  },
  data() {
    return {
      searchResult: undefined,
      class: '',
      loading: false,
      value: 0,
      location: undefined,
      showAnimation: false,
      minDaysForecast: 29,
      maxDaysForecast: 6,
      source: ['26', '2', '22'],
      idClick: undefined,
      qoper: null
    };
  },
  computed: {
    forecasts() {
      return this.$store.getters.forecasts;
    },
    siprecDailyEstimated() {
      return this.$store.getters.siprecDailyEstimated;
    },
    prevHidroDaily() {
      return this.$store.getters.prevHidroDaily;
    },
    flowForecasts() {
      return this.$store.getters.flowForecasts;
    },
    waterAvailability() {
      return this.$store.getters.waterAvailability;
    },
    q95() {
      return this.$store.getters.q95;
    },
    q95_50() {
      return this.$store.getters.q95_50;
    },
  },
  methods: {
    resultLocation(location) {
      this.location = location;
      this.initializeData();
    },
    loadAnimationComplete() {
      this.showAnimation = this.loading;
    },
    async initializeData() {
      this.loading = true;
      this.showAnimation = true;
      // new requisitons
      await this.$store.dispatch('loadSiprecDailyEstimated', {
        startDate: moment().subtract(179, 'days').format('YYYY-MM-DD'),
        endDate: moment().format('YYYY-MM-DD'),
        locationId: this.location.locationid,
      });
      await this.$store.dispatch('loadPrevHidroDaily', {
        startDate: moment().subtract(89, 'days').format('YYYY-MM-DD'),
        endDate: moment().format('YYYY-MM-DD'),
        locationId: this.location.locationid,
      });
      const CurrentlocationID = this.location.locationid;
      if(CurrentlocationID != null) {

        const url = `/forecasts-infohidro-api/parametroalerta_operacional/${CurrentlocationID}`
        try {
          const qoperAux = await axios.get(url);
          this.qoper = qoperAux.data[0].valor;
        } catch {
          this.qoper = null;
        }
      } else {
        this.qoper = null;
      }

      await Promise.all([
        this.$store.dispatch('loadForecastByLocationId', {
          type: 'daily',
          initial_date: moment()
            .subtract(this.minDaysForecast, 'days')
            .format('YYYY-MM-DD'),
          final_date: moment()
            .add(this.maxDaysForecast, 'days')
            .format('YYYY-MM-DD'),
          source: this.source,
          location_id: this.location.locationid,
        }),
        this.$store.dispatch('loadFlowForecastsLocationId', {
          type: 'daily',
          source: '2',
          location_id: this.location.locationid,
          initial_date: moment()
            .subtract(this.minDaysForecast, 'days')
            .utc()
            .startOf('day')
            .format(),
          final_date: moment()
            .add(this.maxDaysForecast, 'days')
            .utc()
            .startOf('day')
            .format(),
        }),
        this.$store.dispatch('loadWaterAvailability', {
          location_id: this.location.locationid,
        }),
        this.qoper,
        this.$store.dispatch('loadFlowDurationCurve', {
            location_id: this.location.locationid,
        }),
      ]);
      this.loading = false;
    },
    async getSearchResult(url) {
      this.searchResult = url;
    },
  },
};
</script>
<style scoped>
.title-page {
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 28px;
  line-height: 33px;
}

.subtitle-page {
  font-family: Roboto;
  font-style: normal;
  font-weight: 300;
  font-size: 16px;
  line-height: 20px;
}
</style>
